import { render } from "./MainResults.vue?vue&type=template&id=b5f031f8&scoped=true"
import script from "./MainResults.vue?vue&type=script&lang=js"
export * from "./MainResults.vue?vue&type=script&lang=js"

import "./MainResults.vue?vue&type=style&index=0&id=b5f031f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f031f8"]])

export default __exports__